import { render, staticRenderFns } from "./BankPreAccEditorView.vue?vue&type=template&id=9632bf94&scoped=true&"
import script from "./BankPreAccEditorView.vue?vue&type=script&lang=ts&"
export * from "./BankPreAccEditorView.vue?vue&type=script&lang=ts&"
import style0 from "./BankPreAccEditorView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BankPreAccEditorView.vue?vue&type=style&index=1&id=9632bf94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9632bf94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VMenu,VSpacer})
